import React, { useState } from 'react'
import './services.css'

const services = [
    {
        title: 'Web Applications',
        icon: 'bx bx-window-alt services__icon',
        modalTitle: 'Full-Stack Web Applications',
        description: 'Designing and building scalable web applications with React, Next.js, ASP.NET, REST APIs, SQL databases, and clean backend architecture.',
        items: ['Frontend and backend development', 'API design and database integration', 'Responsive interfaces for mobile and desktop']
    },
    {
        title: 'Workflow Automation',
        icon: 'bx bx-flow-chart services__icon',
        modalTitle: 'Workflow Automation & Integrations',
        description: 'Building automated workflows that connect internal systems, transcripts, SQL databases, JSON payloads, notifications, and business operations.',
        items: ['n8n orchestration', 'SQL and JSON data pipelines', 'Process automation and system integrations']
    },
    {
        title: 'AI & Voice Agents',
        icon: 'bx bx-bot services__icon',
        modalTitle: 'AI Assistants and Voice Agents',
        description: 'Developing RAG systems, knowledge bases, prompt-engineered assistants, and voice-agent flows for customer service and operational support.',
        items: ['RAG and knowledge-base systems', 'Voice-agent prompt engineering', 'Support, routing, and ticketing automation']
    },
    {
        title: 'Bots & Desktop Apps',
        icon: 'bx bx-desktop services__icon',
        modalTitle: 'Telegram Bots and Desktop Applications',
        description: 'Creating practical local tools, Telegram bots, and desktop applications for automation, notifications, and small business workflows.',
        items: ['Telegram bot development', 'Windows desktop tools', 'Local client workflow solutions']
    }
]

const Services = () => {
    const [toggleState, setToggleState] = useState(-1);

    return(
        <section className="services section" id="services">
            <h2 className="section__title">Services</h2>
            <span className="section__subtitle">What I build</span>

            <div className="services__container container grid">
                {services.map((service, index) => (
                    <div className="services__content" key={service.title}>
                        <div>
                            <i className={service.icon}></i>
                            <h3 className="services__title">{service.title}</h3>
                        </div>

                        <span className="services__button" onClick={() => setToggleState(index)}>View More
                        <i className="uil uil-arrow-right services__button-icon"></i></span>

                        <div className={toggleState === index ? "services__modal active-modal" : "services__modal"}>
                            <div className="services__modal-content">
                                <i className="uil uil-times services__modal-close" onClick={() => setToggleState(-1)}></i>
                                <h3 className="services__modal-title">{service.modalTitle}</h3>
                                <p className="services__modal-description">
                                    {service.description}
                                </p>

                                <ul className="services__modal-services grid">
                                    {service.items.map((item) => (
                                        <li className="services__modal-service" key={item}>
                                            <i className="uil uil-check-circle services__modal-icon"></i>
                                            <p className="services__modal-info">{item}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Services;
